import "../../new.scss";
import { useState, useEffect, useContext } from "react";
import { ArticulosFormContext } from '../../../context/articulos/ArticulosContext';
import { useParams, useNavigate } from 'react-router-dom';
import { Tabs, Tab, Box } from '@mui/material';
import ConfirmationDialog from "../../../components/dialogs/ConfirmationDialog";
import ErrorDialog from "../../../components/dialogs/ErrorDialog";
import FormField from "../../../components/FormField/FormField";
import FormButtons from "../../../components/FormButtons/FormButtons";
import { handleInputChange } from "./helpersForm/formHandlers";
import Inputs from "./configForm/inputs";
import CaracteristicasGrid from './CaracteristicasGrid/caracteristicasGrid'
import ComboGrid from './ComboGrid/comboGrid';
import { ArticulosCombosState } from '../../../context/articuloscombos/ArticulosCombosState';
import MarcasModal from '../../marcas/marcasModal/marcasModal';
import RamosModal from '../../ramos/ramosModal/ramosModal';
import RubrosModal from '../../rubros/rubrosModal/rubrosModal';
import SubrubrosModal from '../../subrubros/subrubrosModal/subrubrosModal';
import loadingGif from '../../../assets/uploading.gif';
import ImagePreview from "../../../components/preview/imagePreview";
const IP_ADDRESS = process.env.REACT_APP_URL_BACKEND;

export const Form = ({ title }) => {
  const [form, setForm] = useState({
    art_es_combo: "0",
    art_fraccionable: "0",
    art_destacado: "0",
    art_discontinuado: "0",
    art_dias_garantia: "0",
    art_costosinimpuesto: 1,
    art_costosconimpuesto: 1,
    art_iva_cotizacion: "3",
    art_flete: "0",
    art_ivaincluido: "3",
    art_fecha_alta: new Date().toISOString().slice(0, 10),
    art_fecha_um: new Date().toISOString().slice(0, 10),
  });
  const { postArticuloData, patchArticuloData, report,
    caracteristicasData, addItemToArray, viewItemFromArray, updateItemFromArray, deleteItemFromArray
  } = useContext(ArticulosFormContext);
  // ID de edicion 
  const { id } = useParams();
  // Navigate to datagrid
  const navigate = useNavigate();
  //Busqueda de Modales
  const [searchFilterRamo, setSearchFilterRamo] = useState();
  const [searchFilterRubro, setSearchFilterRubro] = useState();
  const [searchFilterSubrubro, setSearchFilterSubrubro] = useState();
  const [searchFilterMarca, setSearchFilterMarca] = useState();
  const [searchFilterRamoDesc, setSearchFilterRamoDesc] = useState();
  const [searchFilterRubroDesc, setSearchFilterRubroDesc] = useState();
  const [searchFilterSubrubroDesc, setSearchFilterSubrubroDesc] = useState();
  const [searchFilterMarcaDesc, setSearchFilterMarcaDesc] = useState();
  const [imageUrlLocal, setImageUrlLocal] = useState(null);
  const [imageUrlServer, setImageUrlServer] = useState(null);
  const [tabIndex, setTabIndex] = useState(0); // Estado para controlar las pestañas
  // Manejo de errors
  const [errors, setErrors] = useState({})
  // Estado de Carga
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Dialogs de advertencia y error
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const nameData = "articulos";
  const saveData = postArticuloData;
  const updateData = patchArticuloData;

  useEffect(() => {
    if (report && Object.keys(report).length > 0) {
      const fraccionableOption = {
        "1": { value: "1", label: 'No' },
        "2": { value: "2", label: 'Si' },
      };
      const fraccionableSeleccionado = fraccionableOption[report.art_fraccionable] || null;
      const ivaOption = {
        "1": { value: "1", label: "21 %" },
        "2": { value: "2", label: "10.5 %" },
        "3": { value: "3", label: "0 %" },
      };
      const ivaSeleccionado = ivaOption[report.art_iva_cotizacion] || null;
      const ivaIncluidoOption = {
        "1": { value: "1", label: "21 %" },
        "2": { value: "2", label: "10.5 %" },
        "3": { value: "3", label: "0 %" },
      };
      const ivaIncluidoSeleccionado = ivaIncluidoOption[report.art_ivaincluido] || null;
      const destacadoOption = {
        false: { value: false, label: 'No' },
        true: { value: true, label: 'Si' },
      };
      const destacadoSeleccionado = destacadoOption[report.art_destacado] || null;
      const diasOption = {
        "0": { value: "0", label: '0 dias' },
        "30": { value: "30", label: '30 dias' },
        "45": { value: "45", label: '45 dias' },
        "60": { value: "60", label: '60 dias' },
        "90": { value: "90", label: '90 dias' },
        "120": { value: "120", label: '6 meses' },
        "1": { value: "1", label: '1 año' },
        "2": { value: "2", label: '2 años' },
        "3": { value: "3", label: '3 años' },
      };
      const diasSeleccionado = diasOption[report.art_dias_garantia] || null;
      const comboOption = {
        0: { value: "0", label: 'No' },
        1: { value: "1", label: 'Si' },
      };
      const comboSeleccionado = comboOption[report.art_es_combo] || null;

      setForm({
        ...report,
        art_fecha_alta: new Date().toISOString().slice(0, 10),
        art_fecha_um: new Date().toISOString().slice(0, 10),
        art_fecha_ultupd: new Date().toISOString().slice(0, 10),
        art_costosinimpuesto: report.art_costosinimpuesto || 0,
        porc_may: ((report.art_npreciomayorista - report.art_npreciocosto) / report.art_npreciocosto) * 100,
        porc_min: ((report.art_nprecioventa - report.art_npreciocosto) / report.art_npreciocosto) * 100,
        art_iva_cotizacion: ivaSeleccionado?.value || "",
        art_ivaincluido: ivaIncluidoSeleccionado?.value || "",
        art_fraccionable: fraccionableSeleccionado?.value || "",
        art_destacado: destacadoSeleccionado?.value || "",
        art_dias_garantia: diasSeleccionado?.value || "",
        art_es_combo: comboSeleccionado?.value || "",
      });
      setImageUrlServer(report.art_imagen);
      setSearchFilterRamo(report.ramo_Id);
      setSearchFilterRubro(report.rubro_Id);
      setSearchFilterSubrubro(report.subrubro_Id);
      setSearchFilterMarca(report.marca_id);
      setSearchFilterRamoDesc(report.Ramo?.descripcion_ramo || 'Sin Ramo');
      setSearchFilterRubroDesc(report.Rubro?.descripcion_rubro || 'Sin Rubro');
      setSearchFilterSubrubroDesc(report.Subrubro?.descripcion_subrubro || 'Sin SubRubro');
      setSearchFilterMarcaDesc(report?.Marca?.mar_desripcion || 'Sin Marca');
    }
  }, [report]);


  useEffect(() => {
    setIsSubmitting(false);
    if (searchFilterRamo) {
      setForm((prevForm) => ({
        ...prevForm,
        ramo_Id: searchFilterRamo, // Asegura que tipoiva_id se actualice si hay descripción
      }));
    } else if (!searchFilterRamoDesc) {
      setSearchFilterRamo();
      setSearchFilterRubro();
      setSearchFilterSubrubro();
      setSearchFilterRamoDesc();
      setSearchFilterRubroDesc();
      setSearchFilterSubrubroDesc();
      setForm((prevForm) => ({
        ...prevForm,
        ramo_Id: null, // Establece la clave con un valor vacío en lugar de eliminarla
        rubro_Id: null, // Establece la clave con un valor vacío en lugar de eliminarla
        subrubro_Id: null, // Establece la clave con un valor vacío en lugar de eliminarla
      }));
    }
  }, [searchFilterRamoDesc, searchFilterRamo]);
  useEffect(() => {
    setIsSubmitting(false);
    if (searchFilterRubro) {
      setForm((prevForm) => ({
        ...prevForm,
        rubro_Id: searchFilterRubro, // Asegura que tipoiva_id se actualice si hay descripción
      }));
    } else if (!searchFilterRubroDesc) {
      setSearchFilterRubro();
      setSearchFilterSubrubro();
      setSearchFilterRubroDesc();
      setSearchFilterSubrubroDesc();
      setForm((prevForm) => ({
        ...prevForm,
        rubro_Id: null, // Establece la clave con un valor vacío en lugar de eliminarla
        subrubro_Id: null, // Establece la clave con un valor vacío en lugar de eliminarla

      }));
    }
  }, [searchFilterRubroDesc, searchFilterRubro]);
  useEffect(() => {
    setIsSubmitting(false);
    if (searchFilterSubrubro) {
      setForm((prevForm) => ({
        ...prevForm,
        subrubro_Id: searchFilterSubrubro, // Asegura que tipoiva_id se actualice si hay descripción
      }));
    } else if (!searchFilterSubrubroDesc) {
      setSearchFilterSubrubro();
      setSearchFilterSubrubroDesc();
      setForm((prevForm) => ({
        ...prevForm,
        subrubro_Id: null, // Establece la clave con un valor vacío en lugar de eliminarla
      }));
    }
  }, [searchFilterSubrubroDesc, searchFilterSubrubro]);
  useEffect(() => {
    setIsSubmitting(false);
    if (searchFilterMarca) {
      setForm((prevForm) => ({
        ...prevForm,
        marca_id: searchFilterMarca, // Asegura que tipoiva_id se actualice si hay descripción
      }));
    } else if (!searchFilterMarcaDesc) {
      setSearchFilterMarca();
      setForm((prevForm) => ({
        ...prevForm,
        marca_id: null, // Establece la clave con un valor vacío en lugar de eliminarla
      }));
    }
  }, [searchFilterMarcaDesc, searchFilterMarca]);


  const handleCancel = () => {
    navigate(`/${nameData}`);
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleChange = (e) => {
    handleInputChange(e, setForm, Inputs(id), setErrors, form, setImageUrlLocal);
  };

  const validateForm = () => {
    let formErrors = {};
    Inputs(id).forEach(({ name, validation }) => {
      if (validation) {
        const error = validation(form[name] || "", form);
        if (error) formErrors[name] = error;
      }
    });
    setErrors(formErrors);
    return !Object.keys(formErrors).length;
  };
  // Mostrar diálogos
  const openConfirmDialog = () => setIsConfirmDialogOpen(true);
  const closeConfirmDialog = () => setIsConfirmDialogOpen(false);

  const openErrorDialog = (message) => {
    setErrorMessage(message);
    setIsErrorDialogOpen(true);
  };
  const closeErrorDialog = () => setIsErrorDialogOpen(false);


  // Enviar datos
  const handleSendData = () => {
    if (!validateForm()) {
      // Usamos un callback para asegurarnos de que `errors` esté actualizado
      setErrors((prevErrors) => {
        const errorMessagesArray = Inputs(id).reduce((acc, { name, label }) => {
          if (prevErrors[name]) {
            const fieldLabel = label || name; // Usar el label si existe, si no, usar el nombre del campo
            acc.push(`${fieldLabel}: ${prevErrors[name]}`);
          }
          return acc;
        }, []);
        // Solo abrimos el diálogo de error cuando se hayan generado los mensajes
        if (errorMessagesArray.length > 0) {
          openErrorDialog(errorMessagesArray || "por favor verifique os errores");
        }

        return prevErrors; // No modificamos el estado aquí
      });

      return;
    }
    openConfirmDialog();
  };

  const confirmSendData = async () => {
    setIsSubmitting(true);
    closeConfirmDialog();
    const formData = new FormData();

    delete form.porc_may;
    delete form.porc_min;
    delete form.Ramo;
    delete form.Rubro;
    delete form.Subrubro;
    delete form.Marca;
    if (!imageUrlLocal) {
      delete form.imagen;
    }

    // Filtrar campos vacíos
    for (const key in form) {
      if (form[key] !== null && form[key] !== undefined && form[key] !== '') {
        formData.append(key, form[key]);
      }
    }
    try {
      if (id) {
        if (caracteristicasData.combo.length > 0) {
        }
        await updateData(id, formData);
      } else {
        await saveData(formData);
      }
      navigate(`/${nameData}`); // Navegar después de guardar exitosamente
    } catch (error) {
      console.error('Error al guardar los datos', error);
    } finally {
      setIsSubmitting(false);  // Restablecer el estado de carga después de la operación
    }

  };
  return (
    <div className="new">
      <div className="newContainer">
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="right">
            <Tabs
              value={tabIndex}
              onChange={handleTabChange}
              className="tabs-container"
            >
              <Tab label="General" />
              <Tab label="Precios" />
              <Tab label="Combo" />
              <Tab label="Multimedia" />
              <Tab label="Caracteristicas" />
            </Tabs>
            {/* TAB GENERAL*/}
            <Box sx={{ padding: 2 }}>
              {tabIndex === 0 && (
                <>
                  <form>
                    {Inputs(id).slice(0, 12).map((input) => {
                      let inputElement;

                      // Lógica para renderizar el tipo de input basado en el nombre del campo
                      if (input.type === 'select') {
                        if (input.name === "ramo_Id") {
                          inputElement = (
                            <div className="formInput" key={input.id}>
                              <label>{input.label}</label>
                              <RamosModal
                                handleChange={setSearchFilterRamo}
                                handleDescChange={setSearchFilterRamoDesc}
                                descSelected={searchFilterRamoDesc}
                              />
                              {errors[input.name] && (
                                <p className="error">{errors[input.name]}</p>
                              )}
                            </div>
                          );
                        } else if (input.name === "rubro_Id" && searchFilterRamo) {
                          inputElement = (
                            <div className="formInput" key={input.id}>
                              <label>{input.label}</label>
                              <RubrosModal
                                handleChange={setSearchFilterRubro}
                                handleDescChange={setSearchFilterRubroDesc}
                                idSelectorRam={searchFilterRamo}
                                descSelected={searchFilterRubroDesc}
                              />
                            </div>
                          );
                        } else if (input.name === "subrubro_Id" && searchFilterRamo && searchFilterRubro) {
                          inputElement = (
                            <div className="formInput" key={input.id}>
                              <label>{input.label}</label>
                              <SubrubrosModal
                                handleChange={setSearchFilterSubrubro}
                                handleDescChange={setSearchFilterSubrubroDesc}
                                idSelectorRam={searchFilterRamo}
                                idSelectorRub={searchFilterRubro}
                                descSelected={searchFilterSubrubroDesc}
                              />
                            </div>
                          );
                        } else if (input.name === "marca_Id") {
                          inputElement = (
                            <div className="formInput" key={input.id}>
                              <label>{input.label}</label>
                              <MarcasModal
                                handleChange={setSearchFilterMarca}
                                handleDescChange={setSearchFilterMarcaDesc}
                                descSelected={searchFilterMarcaDesc}
                              />
                            </div>
                          );
                        } else {
                          inputElement = (
                            <div className="formInput" key={input.id}>
                              <label>{input.label}</label>
                              <select
                                name={input.name}
                                onChange={handleChange}
                                value={form[input.name] || ''}
                                className={errors[input.name] ? 'inputError' : ''}
                              >
                                <option value="" disabled selected hidden>
                                  Seleccionar
                                </option>
                                {input.options.map((option) => (
                                  <option key={option.value} value={option.value}>
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                              {errors[input.name] && <p className="error">{errors[input.name]}</p>}
                            </div>
                          );
                        }
                      } else {
                        // Lógica para los inputs de tipo "text", "number", etc.
                        inputElement = (
                          <div className="formInput" key={input.id}>
                            <label>{input.label}</label>
                            <input
                              type={input.type}
                              name={input.name}
                              placeholder={input.placeholder}
                              onChange={handleChange}
                              value={form[input.name] || ''}
                              className={errors[input.name] ? 'inputError' : ''}
                            />
                            {errors[input.name] && <p className="error">{errors[input.name]}</p>}
                          </div>
                        );
                      }

                      return inputElement;
                    })}
                  </form>

                </>
              )}

              {/* TAB PRECIOS*/}
              {tabIndex === 1 && (
                <>
                  <form>
                    {
                      Inputs(id).slice(12, 26).map((input) => (
                        <FormField
                          input={input}
                          value={form[input.name]}
                          handleInputChange={handleChange}
                          error={errors[input.name]}
                        />
                      ))
                    }
                  </form>
                </>
              )}
              {/* TAB COMBO*/}
              {tabIndex === 2 && (
                <div className="formInput">
                  {Inputs(id).slice(26, 27).map((input) => (
                    <FormField
                      key={input.name} // Agregar un key aquí es importante para React
                      input={input}
                      value={form[input.name]}
                      handleInputChange={handleChange}
                      error={errors[input.name]}
                    />
                  ))}
                  {Number(form.art_es_combo) === 1 && (
                    <ArticulosCombosState>
                      <ComboGrid
                        idCombo={id}
                        dataCarac={caracteristicasData}
                        addCarac={addItemToArray}
                        viewCarac={viewItemFromArray}
                        updateCarac={updateItemFromArray}
                        removeCarac={deleteItemFromArray}
                      />
                    </ArticulosCombosState>
                  )}
                </div>
              )}


              {tabIndex === 3 && (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                  {/* Vista previa usando el componente ImagePreview */}
                  {!isSubmitting && (
                    <ImagePreview
                      title="Vista previa del logo"
                      imageUrl={imageUrlLocal || (imageUrlServer && `${IP_ADDRESS}${imageUrlServer}`)}
                    />
                  )}

                  {/* Animación de cargando */}
                  {isSubmitting && (
                    <div className="loading-spinner">
                      <img src={loadingGif} alt="Cargando..." />
                    </div>
                  )}

                  {/* Formulario */}
                  <form>
                    {Inputs(id).slice(27, 28).map((input) => (
                      <FormField
                        input={input}
                        value={form[input.name]}
                        handleInputChange={handleChange}
                        error={errors[input.name]}
                      />
                    ))}
                  </form>
                </div>
              )}

              {/* TAB CARACTERISTICAS*/}
              {tabIndex === 4 && (
                <CaracteristicasGrid
                  datoIdArticulo={form.id}
                  dataCarac={caracteristicasData}
                  addCarac={addItemToArray}
                  removeCarac={deleteItemFromArray}
                />
              )}
            </Box>
            <form> </form>
              <FormButtons
                isSubmitting={isSubmitting}
                handleSave={handleSendData}
                handleCancel={handleCancel}
                saveText="Guardar"
                cancelText="Cancelar"
              />
            
            {/* Diálogos */}
            <ConfirmationDialog
              isOpen={isConfirmDialogOpen}
              onClose={closeConfirmDialog}
              onConfirm={confirmSendData}
              title=""
              message="¿Estás seguro de que deseas guardar este registro?"
            />
            <ErrorDialog
              isOpen={isErrorDialogOpen}
              onClose={closeErrorDialog}
              messages={errorMessage}
              title="Error"
            />
          </div>
        </div>
      </div >
    </div >
  );

};

export default Form;
